import { CheckInDto } from '@careapp-group/ng-sdk';
import { createSelector } from '@ngrx/store';
import { CHECK_INS, CUSTOMERS, getAll, getSelectedId } from '../reducers';

export const checkInsForSelectedCustomer = createSelector(
  getSelectedId(CUSTOMERS),
  getAll(CHECK_INS),
  (customerId, checkIns) => {
    return (checkIns as Array<CheckInDto>).filter((checkIn) => checkIn.customerId === customerId);
  }
);

export const checkInCountForSelectedCustomer = createSelector(
  checkInsForSelectedCustomer,
  (checkIns) => (checkIns as Array<any>).length
);

export const checkInCount = createSelector(
  getAll(CHECK_INS),
  (checkIns) => (checkIns as Array<any>).length
);

/**
 * Returns the check ins currently in the store, removing ones without a location.
 */
export const checkInsWithLocation = createSelector(getAll(CHECK_INS), (state) => {
  return (<Array<CheckInDto>>state).filter(
    (checkIn) => checkIn.location !== null && checkIn.location !== undefined
  );
});
